<template>
  <el-drawer
    title="编辑"
    custom-class="image-edit-panel"
    append-to-body
    direction="rtl"
    :size="400"
    :modal="false"
    :visible.sync="showPanel"
    :before-close="handlePanelClose"
  >
    <div class="image-list">
      <draggable
        v-model="dragableImgs"
        :animation="200"
        :group="'imageSwiperList'"
        :disabled="mode !== 'edit'"
        :ghostClass="'ghost'"
        @start="drag = true"
        @end="drag = false"
        @change="handleSortImg"
      >
        <div class="image-box" v-for="(item, index) in imgs" :key="index">
          <img :src="item" alt="" />
          <div class="edit-btns">
            <button class="btn edit-btn">
              <upload-image
                type="edit"
                :data="item"
                @onImageUploaded="imageList => handleImageUploaded(imageList, 'update', index)"
              >
                <i class="icon wiki-editable-edit"></i>
              </upload-image>
            </button>
            <button class="btn delete-btn" @click.stop="handleDeleteImage(index)">
              <i class="icon wiki-editable-delete"></i>
            </button>
          </div>
        </div>
      </draggable>
      <!-- 上传图片 -->
      <div class="upload-image-btn">
        <upload-image multiple @onImageUploaded="imageList => handleImageUploaded(imageList, 'add')">
          <div class="upload-box">
            <div class="upload-icon">
              <i class="iconfont icon-tianjia"></i>
            </div>
            <div class="upload-desc">添加图片</div>
          </div>
        </upload-image>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import draggable from "vuedraggable";
// components
import UploadImage from "../../../components/UploadImage";

export default {
  name: "ImageEditPanel",
  components: {
    draggable,
    UploadImage
  },
  props: {
    mode: String,
    imgs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showPanel: false,
      uploadType: "add",
      uploadIndex: 0,
      dragableImgs: this.imgs,
      drag: false
    };
  },
  watch: {
    imgs(val) {
      this.dragableImgs = val;
    }
  },
  mounted() {},

  methods: {
    open() {
      this.showPanel = true;
    },
    handlePanelClose() {
      this.showPanel = false;
    },
    handleSortImg() {
      this.$emit("onChange", this.dragableImgs);
    },
    handleUpdateImage(imageList, index) {
      if (index == -1) return;
      const url = imageList[0];
      const imgs = this.imgs;
      imgs.splice(index, 1, url);
      this.$emit("onChange", imgs);
    },
    handleDeleteImage(index) {
      const imgs = this.imgs;
      imgs.splice(index, 1);
      this.$emit("onChange", imgs);
    },
    handleAddImage(imageList) {
      let imgs = this.imgs;
      imgs = imgs.concat(imageList);
      this.$emit("onChange", imgs);
    },
    handleImageUploaded(imageList, type, index) {
      if (type == "add") {
        this.handleAddImage(imageList);
      } else {
        this.handleUpdateImage(imageList, index);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.image-edit-panel {
  .image-list {
    padding: 15px;
  }
  .image-box {
    position: relative;
    display: inline-flex;
    width: 106px;
    height: 106px;
    border-radius: 8px;
    border: 1px solid #d8d8d8;
    margin-right: 16px;
    margin-bottom: 16px;
    &:hover {
      .edit-btns {
        display: inline-flex;
      }
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .edit-btns {
      display: none;
      position: absolute;
      height: 20px;
      right: 3px;
      top: 3px;
      .btn {
        width: 20px;
        height: 20px;
        color: #ffffff;
        border-radius: 4px;
        margin-left: 3px;
        border: none;
        vertical-align: middle;
        line-height: 20px;
        text-align: center;
        &:hover {
          opacity: 0.9;
        }
        .icon {
          display: inline-block;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .upload-image-btn {
    width: 106px;
    height: 106px;
    border-radius: 8px;
    background: #727c86;
    border: 2px solid #ffffff;

    cursor: pointer;
    vertical-align: top;
    .upload-box {
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .upload-icon {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.18);
      text-align: center;
      line-height: 32px;
      font-size: 18px;
      margin-bottom: 12px;
      color: #fff;
    }
    .upload-desc {
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
      line-height: 17px;
    }
  }
}
</style>
